import { useState, useEffect, useRef, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faShare, faSync } from '@fortawesome/free-solid-svg-icons';
import './App.css';
import pickRateImage from './PickRate.png';

// Enhanced modern themes
const THEMES = {
  //device: {
  //  name: 'Device',
  //  primary: '#9b59b6', // Rich purple
  //  secondary: '#8e44ad', // Deep violet
  //  accent: '#fd5c63', // Hot pink/red-orange
  //  background: 'linear-gradient(135deg, #2d0b48 0%, #6a0572 50%, #b3399b 100%)',
  //  text: '#ffffff',
  //  card: 'rgba(255, 255, 255, 0.08)',
  //  button: '#ffffff',
  //  buttonText: '#2d0b48'
  //},
  //light: {
  //  name: 'Light',
  //  primary: '#6a1b9a',
  //  secondary: '#ab47bc',
  //  accent: '#f48fb1',
  //  background: '#f9f9f9',
  //  text: '#222222',
  //  card: 'rgba(90, 90, 90, 0.52)',
  //  button: '#6a1b9a',
  //  buttonText: '#ffffff'
  //},
  dark: {
    name: 'Dark',
    primary: '#1e1e2f',
    secondary: '#2a2a40',
    accent: '#ec407a',
    background: '#121212',
    text: '#e0e0e0',
    card: 'rgba(255, 255, 255, 0.05)',
    button: '#ec407a',
    buttonText: '#ffffff'
  },
  //tinder: {
  //  name: 'Tinder',
  //  primary: '#ff385c',
  //  secondary: '#ff5a5f',
  //  accent: '#ffc107',
  //  background: 'linear-gradient(135deg, #ff385c 0%, #ff5a5f 100%)',
  //  text: '#ffffff',
  //  card: 'rgba(255, 255, 255, 0.08)',
  //  button: '#ffffff',
  //  buttonText: '#ff385c'
  //},
  ocean: {
    name: 'Ocean',
    primary: '#0077b6',
    secondary: '#023e8a',
    accent: '#90e0ef',
    background: 'linear-gradient(135deg, #0077b6 0%, #00b4d8 100%)',
    text: '#ffffff',
    card: 'rgba(255, 255, 255, 0.08)',
    button: '#ffffff',
    buttonText: '#023e8a'
  },
  forest: {
    name: 'Forest',
    primary: '#2e7d32',
    secondary: '#66bb6a',
    accent: '#b9fbc0',
    background: 'linear-gradient(135deg, #1b5e20 0%, #388e3c 100%)',
    text: '#ffffff',
    card: 'rgba(255, 255, 255, 0.08)',
    button: '#ffffff',
    buttonText: '#1b5e20'
  }
};

const SERVER_MANAGER_URL = 'https://pickrate-manager.onrender.com/server?advanced';
const SERVER_MANAGER_URL2 = 'https://formidable-claudie-htdevs-924fa6d6.koyeb.app/server?advanced=full'

const pingServer = async (url) => {
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3000);

    const start = Date.now();
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors', // use 'cors' if it's a different domain, or 'same-origin' if on same server
      signal: controller.signal
    });

    clearTimeout(timeout);

    const text = await response.json();
    if (text.trim() === "Pong") {
      return Date.now() - start; // return latency in ms
    } else {
      return null; // response was not "Pong"
    }
  } catch (error) {
    return null; // server is offline, blocked, or timed out
  }
};



function App() {
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [userAnswer, setUserAnswer] = useState(null);
  const [showStats, setShowStats] = useState(false);
  const [stats, setStats] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showSettings, setShowSettings] = useState(false);
  const [themeMode, setThemeMode] = useState('device');
  const [selectedServer, setSelectedServer] = useState('auto');
  const [serverList, setServerList] = useState([]);
  const [showServerList, setShowServerList] = useState(false);
  const [isLoadingServers, setIsLoadingServers] = useState(false);
  const [lastServerFetch, setLastServerFetch] = useState(0);
  const [serverfetchtry, setserverfetchtry] = useState(0);
  const [activeServerUrl, setActiveServerUrl] = useState(null);
  const questionRef = useRef(null);
  const [toasts, setToasts] = useState([]);
  const toastQueue = useRef([]);
  const processingToast = useRef(false);



  const processToastQueue = useCallback(() => {
    if (toastQueue.current.length === 0) {
      processingToast.current = false;
      return;
    }
    
    processingToast.current = true;
    const nextToast = toastQueue.current.shift();
    
    setToasts([nextToast]);
    
    // Auto-dismiss after 3 seconds
    setTimeout(() => {
      setToasts([]);
      setTimeout(processToastQueue, 300); // Wait for exit animation
    }, 3000);
  }, []);

    // Toast function
  const showToast = useCallback((message, type = 'info') => {
    const id = Date.now();
    const newToast = { id, message, type };
    
    // Add to queue
    toastQueue.current.push(newToast);
    
    // Process queue if not already processing
    if (!processingToast.current) {
      processToastQueue();
    }
  }, [processToastQueue]);

  const closeToast = useCallback(() => {
    setToasts([]);
    setTimeout(processToastQueue, 300);
  }, [processToastQueue]);

  // Attach to window for easy access
  useEffect(() => {
    window.toast = showToast;
    return () => {
      delete window.toast;
    };
  }, [showToast]);
  
  // Map server URLs to display names
  //const getServerDisplayName = (server) => {
  //  if (server === 'auto') return 'Auto (Recommended)';
  //  
  //  // If server is an object with label, use it
  //  if (typeof server === 'object' && server.label) {
  //    return server.label;
  //  }
  //  
  //  // If server is a string (URL), extract domain name
  //  const url = typeof server === 'string' ? server : server.url;
  //  const domain = url.replace(/^https?:\/\/(www\.)?/, '');
  //  const parts = domain.split('.');
  //  if (parts.length > 2) {
  //    return `${parts[0].charAt(0).toUpperCase()}${parts[0].slice(1)} Server`;
  //  }
  //  return domain;
  //};

  // Get server display name from server list
  const getServerDisplayNameFromList = (serverUrl) => {
    if (serverUrl === 'auto') return 'Auto (Recommended)';
    
    const server = serverList.find(s => s.url === serverUrl);
    if (server && server.label) {
      return server.label;
    }
    
    // Fallback to URL parsing
    const domain = serverUrl.replace(/^https?:\/\/(www\.)?/, '');
    const parts = domain.split('.');
    if (parts.length > 2) {
      return `${parts[0].charAt(0).toUpperCase()}${parts[0].slice(1)} Server`;
    }
    return domain;
  };

  // Get ping status color
const getPingColor = (ping) => {
  if (ping < 30) {
    return '#00e676'; // Ultra green (bright green)
  }

  if (ping < 150) {
    return '#4CAF50'; // Normal green
  }

  if (ping < 300) {
    return '#FFC107'; // Yellow
  }

  return '#F44336'; // Red
};


  // Get active server URL
  const getActiveServerUrl = useCallback(() => {
    if (selectedServer === 'auto') {
      const bestServer = serverList.find(s => s.status === 'success');
      return bestServer ? bestServer.url : null;
    }
    return selectedServer;
  }, [selectedServer, serverList]);
  
  // Get active theme
  const getActiveTheme = () => {
    if (themeMode === 'device') {
      const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
      return isDarkMode ? THEMES.dark : THEMES.light;
    }
    return THEMES[themeMode] || THEMES.device || THEMES.dark;
  };
  
  const theme = getActiveTheme();

  // Toast component
const Toast = ({ message, type, onClose }) => {
  const dotColors = {
    info: '#2196F3',     // Blue
    success: '#4CAF50',  // Green
    warning: '#FF9800',  // Orange
    error: '#F44336',    // Red
  };

  const dotColor = dotColors[type] || dotColors.info;

  return (
    <motion.div
      className="toast"
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      transition={{ type: 'spring', damping: 25, stiffness: 300 }}
      style={{ background: getActiveTheme().card }}
    >
      <div className="toast-dot" style={{ background: dotColor }} />
      <div className="toast-message">{message}</div>
      <button className="toast-close" onClick={onClose}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </motion.div>
  );
};

  // Calculate dynamic font size based on question length
  const getQuestionFontSize = (question) => {
    if (!question) return '1.8rem';
    const length = question.length;
    
    if (length <= 50) return '2rem';
    if (length <= 100) return '1.7rem';
    if (length <= 150) return '1.5rem';
    return '1.3rem';
  };

  function sharequestion() {
    const qid = currentQuestion.id;
    const shareUrl = `https://pickrate.pages.dev?question=${qid}&server=${selectedServer}`;
    const shareTitle = "Check out this question on PickRate!";
    const shareText = "I found this interesting question on PickRate. What do you think?";

    if (navigator.share) {
      navigator.share({
        title: shareTitle,
        text: shareText,
        url: shareUrl,
      })
        .then(() => console.log('Successful share'), console.clear())
        .catch((error) => console.error('Error sharing:', error));
    } else {
      navigator.clipboard.writeText(shareUrl)
        .then(() => alert("Link copied to clipboard! Share it with your friends."))
        .catch((err) => console.error('Could not copy text: ', err));
    }
  }

  function updateParamWithoutReload(key, value) {
    const params = new URLSearchParams(window.location.search);
    params.set(key, value);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState(null, '', newUrl);
  }

  // Fetch a new question
const fetchQuestion = useCallback(async (except = null, id) => {
  setIsLoading(true);
  
  try {
    const API_BASE_URL = getActiveServerUrl();
    if (!API_BASE_URL) {
      console.log('No active server, skipping fetch');
      return;
    }
    
    const url = new URL(`${API_BASE_URL}/getnewquestion`);
    if (except) url.searchParams.append('except', except);
    if (id) url.searchParams.append('id', id);
    
    const response = await fetch(url, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 404) {
      window.toast('Server failed to get new question.', 'error');
      // Don't automatically switch servers - just show error
    }

    const data = await response.json();
    setCurrentQuestion(data);
    updateParamWithoutReload('question', data.id);
    
  } catch (error) {
    console.error('Error fetching question:', error);
    window.toast('Failed to fetch question. Please try again or change servers.', 'error');
    
    // REMOVED THE AUTOMATIC SERVER SWITCHING CODE
    // Just show error without changing server preference
  } finally {
    setIsLoading(false);
  }
}, [getActiveServerUrl]); // Removed selectedServer dependency
  
  const calculateUpdatedStats = (currentStats, userAnswer, totalAnswers) => {
    const counts = { ...currentStats };
    counts[userAnswer] = (counts[userAnswer] || 0) + 1;
    const newTotal = totalAnswers + 1;

    const newStats = {};
    Object.entries(counts).forEach(([option, count]) => {
      newStats[option] = Math.round((count / newTotal) * 100);
    });

    const totalPercent = Object.values(newStats).reduce((sum, val) => sum + val, 0);
    if (totalPercent !== 100) {
      newStats[userAnswer] += (100 - totalPercent);
    }

    return newStats;
  };

  // Submit answer
  const submitAnswer = async (answer) => {
    if (!currentQuestion || userAnswer) return;
    
    setUserAnswer(answer);
    
    try {
      const API_BASE_URL = getActiveServerUrl();
      if (!API_BASE_URL) return;
      
      const url = new URL(`${API_BASE_URL}/answerquestion`);
      url.searchParams.append('questionid', currentQuestion.id);
      url.searchParams.append('answer', encodeURIComponent(answer));
      
      const response = await fetch(url, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' }
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    } catch (error) {
      console.error('Error submitting answer:', error);
    }
    
    // Generate stats using actual vote counts from API
    const newStats = calculateUpdatedStats(
      currentQuestion.answers, 
      answer, 
      currentQuestion.answers_number
    );
    
    setStats(newStats);
    setShowStats(true);
    
    // Move to next question after 2s
    setTimeout(() => {
      fetchQuestion(currentQuestion.id);
      setUserAnswer(null);
      setShowStats(false);
    }, 2000);
  };

  // Skip question
  const skipQuestion = () => {
    if (currentQuestion) {
      fetchQuestion(currentQuestion.id);
    }
  };

  // Save theme preference
  const saveThemePreference = (theme) => {
    setThemeMode(theme);
    localStorage.setItem('themePreference', theme);
  };

  // Save server preference
  const saveServerPreference = (server) => {
    setSelectedServer(server);
    localStorage.setItem('serverPreference', server);
    setShowServerList(false);
  };

  // Fetch server list
const fetchServers = useCallback(async (show_loader = true, try_next_url = false) => {
  const now = Date.now();
  if (now - lastServerFetch < 2000) return;
  setLastServerFetch(now);

  const url = try_next_url ? SERVER_MANAGER_URL2 : SERVER_MANAGER_URL;
  setIsLoadingServers(show_loader);

  try {
    const response = await fetch(url);
    const data = await response.json();

    let servers = [];
    if (data.servers) {
      servers = data.servers;
    } else if (data.mirrors) {
      servers = data.mirrors.map(mirror => ({
        url: mirror.url,
        label: mirror.label
      }));
    } else if (data.url) {
      servers = [{ url: data.url, label: data.label || 'Main Server' }];
    }

    const pingedServers = await Promise.all(
      servers.map(async server => {
        const time = await pingServer(`${server.url}/ping`);
        return {
          ...server,
          time,
          status: time !== null ? 'success' : 'error'
        };
      })
    );

    pingedServers.sort((a, b) => {
      if (a.status === 'success' && b.status !== 'success') return -1;
      if (b.status === 'success' && a.status !== 'success') return 1;
      if (a.status === 'success' && b.status === 'success') {
        return a.time - b.time;
      }
      return 0;
    });

    setServerList(pingedServers);
  } catch (error) {
    console.error('Error fetching servers:', error);
    setServerList([]);

    if (serverfetchtry < 1) {
      setserverfetchtry(prev => prev + 1);
      fetchServers(true, true);
    } else {
      alert("Could not fetch servers. Please try again later.");
    }
  } finally {
    setIsLoadingServers(false);
  }
}, [lastServerFetch, serverfetchtry]);

  // Update active server URL
  useEffect(() => {
    const url = getActiveServerUrl();
    setActiveServerUrl(url);
    
    // If we have a valid server but no question, fetch one
    if (url && !currentQuestion) {
      const urlParams = new URLSearchParams(window.location.search);
      const questionId = urlParams.get('question');
      fetchQuestion(null, questionId);
    }
  }, [getActiveServerUrl, currentQuestion, fetchQuestion]);

  // Initial fetch and load saved theme
useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const serverParam = urlParams.get('server');

  // Load server preferences
  const savedServer = localStorage.getItem('serverPreference');
  if (savedServer) {
    setSelectedServer(savedServer);
  } else if (serverParam) {
    setSelectedServer(serverParam);
  } else {
    setSelectedServer('auto');
  }

  // Load theme preferences
  const savedTheme = localStorage.getItem('themePreference');
  if (savedTheme) {
    setThemeMode(savedTheme);
  }
  
  // Fetch initial server list if not already done
  if (serverList.length === 0) {
    fetchServers(true, false);
  }
}, [fetchServers, serverList.length]); // Added serverList.length dependency

  // Update server list when settings open
  useEffect(() => {
    if (showSettings && serverList.length === 0) {
      fetchServers(true);
    }
  }, [showSettings, fetchServers, serverList.length]);

  return (
    <div 
      className="App" 
      style={{ 
        background: theme.background,
        color: theme.text
      }}
    >
      <header className="App-header">
        <div className="header-content">
          <div className="logo-title">
            <img className='logo' src={pickRateImage} alt="PickRate" />
            <h1 className="app-title">PickRate</h1>
          </div>
          <div className="header-buttons">
            <motion.button 
              className="share-btn"
              onClick={() => sharequestion()}
              whileHover={{ scale: 1.1, rotate: -22.5 }}
              whileTap={{ scale: 0.9 }}
              style={{ 
                background: theme.card,
                color: theme.text 
              }}
            >
              <FontAwesomeIcon icon={faShare} />
            </motion.button>
            <motion.button 
              className="settings-btn"
              onClick={() => setShowSettings(true)}
              whileHover={{ rotate: 90, scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              style={{ 
                background: theme.card,
                color: theme.text 
              }}
            >
              <FontAwesomeIcon icon={faGear} />
            </motion.button>
          </div>
        </div>
      </header>

      <main className="card-container">
        {!activeServerUrl ? (
          <motion.div
            className="loading-card"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
              className="spinner"
              style={{ 
                borderTopColor: theme.accent,
                borderWidth: '4px'
              }}
            />
            <p>Loading...</p>
          </motion.div>
        ) : (
          <AnimatePresence mode="wait">
            {isLoading ? (
              <motion.div
                key="loading"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="loading-card"
              >
                <motion.div
                  animate={{ rotate: 360 }}
                  transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                  className="spinner"
                  style={{ 
                    borderTopColor: theme.accent,
                    borderWidth: '4px'
                  }}
                />
              </motion.div>
            ) : showStats ? (
              <motion.div
                key="stats"
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.8, opacity: 0 }}
                className="card stats-card"
                style={{ background: theme.card }}
              >
                <motion.h2
                  initial={{ y: -20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.1 }}
                  className="stats-title"
                >
                  Community Picks
                </motion.h2>
                <div className="stats-container">
                  {stats && Object.entries(stats).map(([answer, value]) => (
                    <div key={answer} className="stat-bar">
                      <div className="stat-label">
                        <span>{answer.charAt(0).toUpperCase() + answer.slice(1)}</span>
                        <span>{value}%</span>
                      </div>
                      <div className="bar-background">
                        <motion.div
                          className="bar-fill"
                          initial={{ width: 0 }}
                          animate={{ width: `${value}%` }}
                          transition={{ duration: 0.5, ease: "easeOut" }}
                          style={{ background: theme.accent }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </motion.div>
            ) : (
              <motion.div
                key="question"
                className="card question-card"
                style={{ background: theme.card }}
                initial={{ scale: 0.95, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.95, opacity: 0 }}
                transition={{ duration: 0.3 }}
              >
                {currentQuestion && (
                  <>
                    <motion.h2
                      ref={questionRef}
                      className="question-text"
                      style={{ 
                        fontSize: getQuestionFontSize(currentQuestion.question),
                        margin: '20px 0 40px'
                      }}
                    >
                      {currentQuestion.question}
                    </motion.h2>
                    
                    <div className="answer-buttons">
                      {Object.keys(currentQuestion.answers).map((answer) => (
                        <motion.button
                          key={answer}
                          whileHover={{ 
                            scale: 1.01,
                            boxShadow: `0 5px 15px ${theme.accent}80`
                          }}
                          whileTap={{ scale: 0.98 }}
                          onClick={() => submitAnswer(answer)}
                          style={{ 
                            background: theme.button, 
                            color: theme.buttonText,
                            borderRadius: '50px',
                            fontWeight: '600'
                          }}
                        >
                          {answer.charAt(0).toUpperCase() + answer.slice(1)}
                        </motion.button>
                      ))}
                    </div>
                    
                    <motion.button
                      className="skip-btn"
                      onClick={skipQuestion}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      style={{ 
                        color: theme.text,
                        fontWeight: '600'
                      }}
                    >
                      Skip Question
                    </motion.button>
                  </>
                )}
              </motion.div>
            )}
          </AnimatePresence>
        )}
      </main>


      <AnimatePresence>
        {showSettings && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="modal-backdrop"
            onClick={() => setShowSettings(false)}
          >
            <motion.div
              initial={{ scale: 0.9, y: 20 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.9, y: 20 }}
              className="settings-modal"
              style={{ background: theme.card }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header">
                <h3>App Settings</h3>
              </div>
              
              {/* Server Selection Section */}
              <div className="server-section">
                <h4>Server Selection</h4>
            <motion.button 
              onClick={() => { setShowServerList(true); setTimeout(() => fetchServers(), 150); }}
              whileHover={{ rotate: 45, scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              style={{ 
                background: 'none',
                backgroundColor: 'none',
                color: theme.text 
              }}
            >
              <FontAwesomeIcon icon={faSync} />
            </motion.button>
                
                <div 
                  className="server-select"
                  onClick={() => setShowServerList(!showServerList)}
                  style={{ background: theme.background }}
                >
                  <div className="selected-server">
                    {getServerDisplayNameFromList(selectedServer)}
                    <span className={`arrow ${showServerList ? 'open' : ''}`}>▼</span>
                  </div>
                  
                  <AnimatePresence>
                    {showServerList && (
                      <motion.div
                        className="server-options"
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        style={{ background: theme.background }}
                      >
                        <div 
                          className={`server-option ${selectedServer === 'auto' ? 'selected' : ''}`}
                          onClick={() => saveServerPreference('auto')}
                        >
                          <div className="server-label">Auto (Recommended)</div>
                          <div className="server-ping">Best available</div>
                        </div>
                        
                        {isLoadingServers ? (
                          <div className="loading-servers">
                            <div 
                              className="spinner"
                              style={{ 
                                borderTopColor: theme.accent,
                                borderWidth: '2px'
                              }}
                            ></div>
                          </div>
                        ) : serverList.map((server, index) => (
                          <div 
                            key={index}
                            className={`server-option ${selectedServer === server.url ? 'selected' : ''} ${server.status}`}
                            onClick={() => saveServerPreference(server.url)}
                          >
                            <div className="server-label">
                              {server.label || server.url.replace('https://', '')}
                              {server.status !== 'success' && (
                                <span className="status-badge">Offline</span>
                              )}
                            </div>
                            <div 
                              className="server-ping"
                              style={{ color: server.status === 'success' ? getPingColor(server.time) : '#F44336' }}
                            >
                              {server.status === 'success' ? `${server.time}ms` : 'Offline'}
                            </div>
                          </div>
                        ))}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
                
                <p className="server-note">
                  Changing servers may improve performance. "Auto" selects the fastest available server.
                </p>
              </div>
              
              {/* Theme Selection */}
              <div className="theme-section">
                <h4>Theme Selection</h4>
                <div className="theme-grid">
                  {Object.entries(THEMES).map(([key, themeObj]) => (
                    <motion.div
                      key={key}
                      className={`theme-option ${themeMode === key ? 'active' : ''}`}
                      onClick={() => saveThemePreference(key)}
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.97 }}
                      style={{ 
                        background: themeObj.card,
                        border: themeMode === key ? `2px solid ${themeObj.accent}` : 'none'
                      }}
                    >
                      <div className="theme-preview">
                        <div style={{ 
                          background: themeObj.background,
                          borderRadius: '8px',
                          height: '30px'
                        }}></div>
                      </div>
                      <span style={{ color: theme.text }}>{themeObj.name}</span>
                    </motion.div>
                  ))}
                </div>
              </div>
              
              <div className="privacy-section" style={{ background: theme.background }}>
                <h4>About PickRate</h4>
                <p>
                  PickRate is just for fun! We do not save any personal information 
                  or device information. All questions are anonymous and we only 
                  collect aggregated answer statistics.
                </p>
              </div>
              
              <motion.button 
                onClick={() => setShowSettings(false)}
                whileTap={{ scale: 0.98 }}
                style={{ 
                  background: theme.accent,
                  color: '#ffffff',
                  fontWeight: '600',
                }}
              >
                Done
              </motion.button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      {/* Toast container */}
      <div className="toast-container">
        <AnimatePresence>
          {toasts.map(toast => (
            <Toast
              key={toast.id}
              message={toast.message}
              type={toast.type}
              onClose={closeToast}
            />
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default App;